import {
  Tile,
  TileContent,
  TileMedia,
  TileText,
  TileTitle,
} from '@design-system';
import Link from 'next/link';

import { Image } from '../../Image';
import SubscribeBell from '../../SubscribeBell';

export const ArtistTile = ({
  href,
  image,
  isSubscribed = false,
  name,
  onClick,
  onClickSubscribe,
  overline,
  subtitle,
}: {
  className?: string;
  href: string;
  image: {
    alt: string;
    eagerLoading?: boolean;
    focus?: string;
    hoverSrc?: string;
    src: string;
  };
  name: string;
  subtitle?: string;
  overline?: string;
  onClick?: () => void;
  isSubscribed?: boolean;
  onClickSubscribe?: () => Promise<void>;
}) => (
  <Tile className="group" direction="column">
    <TileMedia
      overlay={
        <>
          {onClickSubscribe ? (
            <SubscribeBell
              isSubscribed={isSubscribed}
              onClickSubscribe={onClickSubscribe}
            />
          ) : null}
        </>
      }
    >
      <Image
        alt={image.alt}
        eagerLoading={image.eagerLoading}
        src={image.src}
        focus={image.focus}
        hoverEffect
        size={{
          sm: { ratio: '1/1', span: 6 },
          md: { ratio: '1/1', span: 3 },
          lg: { ratio: '1/1', span: 4 },
        }}
      />

      {image.hoverSrc ? (
        <div
          aria-hidden
          className="absolute inset-0 opacity-0 transition duration-300 ease-out group-hover:opacity-100"
        >
          <Image
            alt={image.alt}
            size={{
              sm: { ratio: '1/1', span: 6 },
              md: { ratio: '1/1', span: 3 },
              lg: { ratio: '1/1', span: 4 },
            }}
            src={image.hoverSrc}
            focus={image.focus}
          />
        </div>
      ) : null}
    </TileMedia>

    <TileContent className="w-full" direction="column">
      <TileTitle>
        <Link
          href={href}
          onClick={onClick}
          prefetch={false}
          className="after:absolute after:inset-0 after:block after:content-['']"
        >
          {name}
        </Link>
      </TileTitle>
      {subtitle ? <TileText>{subtitle}</TileText> : null}
      {overline ? (
        <TileText className="mt-3" variant="muted">
          {overline}
        </TileText>
      ) : null}
    </TileContent>
  </Tile>
);
